import { jsxs as r, jsx as o } from "react/jsx-runtime";
const i = ({ width: e = 18, height: t = 18 }) => /* @__PURE__ */ r(
  "svg",
  {
    width: e,
    height: t,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
          fill: "var(--color-infoFeedback-lightest)",
          stroke: "var(--color-infoFeedback-lightest)",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 5.95239H9.00889",
          stroke: "white",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.23798 9H8.99988V12.0476H9.76179",
          stroke: "white",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as InfoIcon
};
